import { selectCurrentViewType } from 'phoenix2/state/views/selectors';
import { getFeatureFlag } from 'phoenix2/state/feature-flags/selectors';
import { FEATURE_FLAG_WAC_METHOD, WAC_METHOD_DISABLED } from 'phoenix2/state/feature-flags';
import { getViewStateFilter } from 'phoenix2/state/viewstates/selectors';

export const isWACShowing = state =>
    state.getIn(['wac', 'showing'], false) &&
    (selectCurrentViewType(state) === 'task' ||
        (selectCurrentViewType(state) === 'packagelist' &&
            getViewStateFilter(state, 'packagelist') === 'revision'));

/**
 * Returns a boolean whether bookwork is disabled by feature flag for the current student
 * @param state
 */
export const isBookworkDisabled = state =>
    getFeatureFlag(state, FEATURE_FLAG_WAC_METHOD) === WAC_METHOD_DISABLED;
